import React from "react";
import "./style.css";

const Footer = props => (
     <div className="footer">
              <p className="text-muted text-center">Version 1.0. </p>
          </div>
  
      )

  export default Footer;